import { useState } from "react";
import { InputAdornment, InputBase, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const SortDropdown = ({ data, setSortedData }) => {
  const [selectedOption, setSelectedOption] = useState("0");

  const handleSortChange = (e) => {
    const sortBy = e.target.value;
    setSelectedOption(sortBy);

    let sortedResults = [...data];

    switch (sortBy) {
      case "0":
        sortedResults = [...data];
        break;
      case "1":
        sortedResults = sortedResults.filter((data) => data.categoryId == 1);
        break;
      case "2":
        sortedResults = sortedResults.filter((data) => data.categoryId == 2);
        break;
      case "3":
        sortedResults = sortedResults.filter((data) => data.categoryId == 3);
        break;
      case "4":
        sortedResults = sortedResults.filter((data) => data.categoryId == 4);
        break;
      default:
        break;
    }
    setSortedData(sortedResults);
  };

  return (
    <Select
      id="dropdown-menu"
      onChange={handleSortChange}
      value={selectedOption}
      input={
        <InputBase
          startAdornment={<InputAdornment position="start"></InputAdornment>}
        />
      }
      sx={{
        p: 0.5,
        background: "transparent",
        color: "#fff",
        border: "1px solid #fff",
        borderRadius: "5px",
        ".MuiSelect-icon": { color: "#fff" },
      }}
      IconComponent={KeyboardArrowDownIcon}
    >
      <MenuItem value="0">All Tiers</MenuItem>
      <MenuItem value="1">Tier One</MenuItem>
      <MenuItem value="2">Tier Two</MenuItem>
      <MenuItem value="3">Tier Three</MenuItem>
      <MenuItem value="4">Tier Four</MenuItem>
    </Select>
  );
};

export default SortDropdown;
